import React from "react";
import AdminMenu from "../../../../../components/Admin/MenuDetalhes/AdminMenu";
import Back from "../Back";
import CreateSegmentForm from "./CreateSegmentForm";
import { Segment, Divider } from "semantic-ui-react";
import { SemanticContainer, SemanticSegment } from "./styled";

const CreateFaqSegment = () => {
  return (
    <>
      <AdminMenu />
      <SemanticContainer>
        <Back actualPage={"Criar Segmento de FAQ"} />
        <h2>Criar Novo Segmento</h2>
        <Divider />
        <Segment>
          <CreateSegmentForm />
        </Segment>
      </SemanticContainer>
      <SemanticContainer>
        <SemanticSegment>
          Grupo Voitto <i class="copyright outline icon"></i>
          {new Date().getFullYear()}
        </SemanticSegment>
      </SemanticContainer>
    </>
  );
};

export default CreateFaqSegment;
